import { useLayoutContext } from "@context/layout";
import useSubscriptionExperiments from "@shared/hooks/useSubscriptionExperiments";
import { Button } from "@shared/components";
import ArrowLeft2Icon from "@svg/new-design/arrow-left2";
import { stringifiedFarsiNum } from "@utils/digits";
import { FC, useMemo } from "react";
import Link from "next/link";
import { twMerge } from "tailwind-merge";
import {
  BUTTON_COLOR,
  BUTTON_SIZE,
  BUTTON_VARIANT,
} from "@shared/components/button";

interface Props {
  className?: string;
}

const FooterSubscriptionBanner: FC<Props> = ({ className }) => {
  const { staticData } = useLayoutContext();
  const { handleLogExperimentSubRecommender } = useSubscriptionExperiments();

  const formattedCountLabel = useMemo(
    () =>
      stringifiedFarsiNum(staticData?.statistics.countOfProducts ?? 0, 17_000),
    [staticData?.statistics.countOfProducts]
  );

  return (
    <div
      className={twMerge(
        "w-full h-full py-6 overflow-hidden subscription-footer-bg ",
        className ?? ""
      )}
    >
      <div className="flex w-full flex-col items-center gap-6 md:flex-row md:items-center md:justify-between md:gap-8 px-6 md:px-16 lg:px-fds-120 xl:px-16 max-w-[1920px] mx-auto">
        <div className="flex w-full flex-col items-start gap-2 md:min-w-0 md:flex-1">
          <p className="text-fds-primary headline-sm md:headline-md md:text-right w-full text-center">
            دسترسی به {formattedCountLabel} آموزش فرادرس
            <br className="md:hidden" /> همه با یک اشتراک{" "}
          </p>
          <p className="hidden md:block body-lg text-fds-secondary text-right">
            با فعال کردن اشتراک فرادرس به صورت یکجا به همه آموزش‌ها دسترسی داشته
            باشید.
          </p>
        </div>
        <Link className="w-full md:w-fit" href="/subscription">
          <Button
            endIcon={<ArrowLeft2Icon />}
            variant={BUTTON_VARIANT.FILL}
            size={BUTTON_SIZE.LARGE}
            color={BUTTON_COLOR.SECONDARY}
            onClick={() =>
              handleLogExperimentSubRecommender({ position: "footer-banner" })
            }
            className="subscription-button-bg group shrink-0 text-fds-primary hover:text-fds-primary active:text-fds-secondary w-full md:w-[215px] md:max-w-[215px] [&_svg]:transition-transform [&_svg]:duration-200 group-hover:[&_svg]:-translate-x-1 group-active:[&_svg]:translate-x-0"
          >
            فعال‌سازی اشتراک
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default FooterSubscriptionBanner;
